import { useCallback, useState } from 'react';
import { handleRealUsedFlag } from '@bingads-webui-campaign-react/asset-library-model';

export const useImageSizeFilter = ({
  logger, preference, realUsedFlagSuffix,
}) => {
  const [minWidthFilter, setMinWidthFilter] = useState(null);
  const [minHeightFilter, setMinHeightFilter] = useState(null);

  const onImageSizeFilterChange = useCallback(({ newMinWidth, newMinHeight }) => {
    if (newMinWidth !== minWidthFilter) {
      logger.logTrace('onImageSizeFilterChange', { minWidth: newMinWidth });
      setMinWidthFilter(newMinWidth);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
    if (newMinHeight !== minHeightFilter) {
      logger.logTrace('onImageSizeFilterChange', { minHeight: newMinHeight });
      setMinHeightFilter(newMinHeight);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [logger, minHeightFilter, minWidthFilter, preference, realUsedFlagSuffix]);

  return {
    minWidthFilter,
    minHeightFilter,
    onImageSizeFilterChange,
  };
};
